import { Link } from 'react-router-dom';
import { Search, ChefHat, Star, MapPin, ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { useAuthStore } from '@/stores/auth-store';
import { formatBRL } from '@rango/shared/utils';

export function HomePage() {
  const { user } = useAuthStore();
  
  return (
    <div className="min-h-screen">
      {/* Header */}
      <header className="bg-gradient-to-br from-rango-500 to-rango-600 px-4 pb-12 pt-8 text-white">
        <div className="mx-auto max-w-lg">
          <p className="text-rango-100">Olá, {user?.name?.split(' ')[0]} 👋</p>
          <h1 className="mt-1 font-display text-2xl font-bold">
            O que você quer fazer hoje?
          </h1>
        </div>
      </header>
      
      {/* Main action cards */}
      <div className="mx-auto -mt-8 max-w-lg px-4">
        <div className="grid grid-cols-2 gap-4">
          {/* QUERO COMER */}
          <Link to="/buscar" className="block">
            <Card className="h-full border-0 shadow-lg transition-transform hover:scale-[1.02]">
              <CardContent className="flex flex-col items-center p-6 text-center">
                <div className="mb-3 flex h-14 w-14 items-center justify-center rounded-xl bg-gradient-to-br from-amber-400 to-orange-500 text-white shadow-md">
                  <Search className="h-7 w-7" />
                </div>
                <h2 className="font-display text-lg font-semibold">Quero Comer</h2>
                <p className="mt-1 text-sm text-muted-foreground">
                  Encontre refeições perto de você
                </p>
              </CardContent>
            </Card>
          </Link>
          
          {/* QUERO COZINHAR */}
          <Link to="/cozinhar" className="block">
            <Card className="h-full border-0 shadow-lg transition-transform hover:scale-[1.02]">
              <CardContent className="flex flex-col items-center p-6 text-center">
                <div className="mb-3 flex h-14 w-14 items-center justify-center rounded-xl bg-gradient-to-br from-emerald-400 to-teal-500 text-white shadow-md">
                  <ChefHat className="h-7 w-7" />
                </div>
                <h2 className="font-display text-lg font-semibold">Quero Cozinhar</h2>
                <p className="mt-1 text-sm text-muted-foreground">
                  Compartilhe sua comida
                </p>
              </CardContent>
            </Card>
          </Link>
        </div>
      </div>
      
      {/* Stats */}
      <div className="mx-auto mt-8 max-w-lg px-4">
        <Card className="border-0 bg-gradient-to-r from-rango-50 to-amber-50">
          <CardContent className="p-4">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-muted-foreground">Seus tokens</p>
                <p className="font-display text-2xl font-bold text-rango-600">
                  {user?.balances.tokens.toLocaleString('pt-BR')}
                </p>
              </div>
              <div className="text-right">
                <p className="text-sm text-muted-foreground">Créditos</p>
                <p className="font-display text-2xl font-bold text-emerald-600">
                  {formatBRL(user?.balances.credits || 0)}
                </p>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
      
      {/* Nearby events section (placeholder) */}
      <div className="mx-auto mt-8 max-w-lg px-4 pb-24">
        <div className="mb-4 flex items-center justify-between">
          <h2 className="font-display text-xl font-semibold">Perto de você</h2>
          <Link to="/buscar" className="flex items-center gap-1 text-sm text-primary">
            Ver todos <ArrowRight className="h-4 w-4" />
          </Link>
        </div>
        
        {/* Empty state */}
        <Card className="border-dashed">
          <CardContent className="flex flex-col items-center justify-center py-12 text-center">
            <MapPin className="mb-3 h-12 w-12 text-muted-foreground/50" />
            <p className="text-muted-foreground">
              Nenhum evento encontrado na sua região ainda.
            </p>
            <Button asChild variant="link" className="mt-2">
              <Link to="/buscar">Buscar refeições</Link>
            </Button>
          </CardContent>
        </Card>
        
        {/* Sample event card (for reference) */}
        <Card className="mt-4 hidden overflow-hidden border-0 shadow-md">
          <div className="aspect-video bg-muted" />
          <CardContent className="p-4">
            <div className="flex items-start justify-between">
              <div>
                <h3 className="font-semibold">Feijoada Completa</h3>
                <p className="text-sm text-muted-foreground">Por Maria Silva</p>
              </div>
              <div className="flex items-center gap-1 text-sm">
                <Star className="h-4 w-4 fill-amber-400 text-amber-400" />
                <span>4.9</span>
              </div>
            </div>
            <div className="mt-3 flex items-center justify-between">
              <div className="flex items-center gap-1 text-sm text-muted-foreground">
                <MapPin className="h-4 w-4" />
                <span>2.3 km</span>
              </div>
              <p className="font-semibold text-primary">{formatBRL(3500)}</p>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}

